import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=03b02306&scoped=true&"
import script from "./DashboardHeader.vue?vue&type=script&lang=ts&"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=03b02306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b02306",
  null
  
)

export default component.exports